import React from 'react';
import { FormattedMessage } from 'react-intl';
import { css } from 'aphrodite/no-important';
import { Heading, IconSingle, Paragraph } from '@trainline/depot-web';

import Link from '@contactcentre-web/common/Link';

import messages from './messages';
import styles from './styles';

interface Props {
  orderReference?: string;
}

const ManualEntryConsoleEditHeader = ({ orderReference }: Props) => (
  <>
    <Link linkType="internal" to="/mec-claim-approvals" styleSheet={styles.backButton}>
      <IconSingle />
      <FormattedMessage {...messages.buttonBack} />
    </Link>
    <div className={css(styles.header)} data-testid="manualEntryConsoleEditHeader">
      <Heading typeStyle="title2" as="h1" color="base">
        <FormattedMessage {...messages.title} />
      </Heading>
      {orderReference && (
        <Paragraph typeStyle="small" as="p" color="subdued" fontWeight="regular">
          <FormattedMessage
            {...messages.orderReference}
            values={{ orderReference: <strong>{orderReference}</strong> }}
          />
        </Paragraph>
      )}
    </div>
  </>
);
export default ManualEntryConsoleEditHeader;
